<script>
import {
  measureDetailsComputed,
  measureDetailsMethods,
} from '@state/helpers/measure-details'
import cloneDeep from 'lodash/cloneDeep'
import { COMMENT_LEVEL } from '@utils/constant'
import infoItems from './details/infoItems'

export default {
  COMMENT_LEVEL,
  page: {
    title: 'Measure detail',
    meta: [{ name: 'description', content: 'The Measure detail page.' }],
  },
  data() {
    return {
      infoItems: infoItems,
      items: cloneDeep(infoItems),
      buttonTitle: this.$t('confirm.delete.btn'),
      title: this.$t('pages.measureDetail'),
    }
  },
  computed: {
    ...measureDetailsComputed,
    itemsComputed() {
      if (this.getMeasureDetails) {
        const details = this.getMeasureDetails
        return this.items?.map((item) => {
          const kgitems = [
            'weight',
            'bone_mass',
            'muscle_mass',
            'lean_body_weight',
          ]
          const percents = [
            'body_fat_rate',
            'body_water_rate',
            'muscle_rate',
            'subcutaneous_fat',
            'protein',
          ]
          const origins = ['metabolic_age', 'visceral_fat', 'BMI']
          item.value = details[item.key]
          item.subValue = details.data[item.comment]
          if (details.mac === '' && item.key === 'mac') {
            item.value = '-'
          }
          if (!details.gender && item.key === 'gender') {
            item.value = '男'
          }
          if (item.key === 'athlete') {
            item.value = !details.athlete ? 'いいえ' : 'はい'
          }
          if (item.key === 'BMR') {
            item.value = `${details.data.BMR}kcal`
          }
          if (item.key === 'height') {
            item.value = `${details.height}cm`
          }
          kgitems.map((kgitem) => {
            if (item.key === kgitem) {
              item.value = `${details.data[kgitem]}kg`
            }
          })
          percents.map((percent) => {
            if (item.key === percent) {
              const value = parseFloat(details.data[percent]).toFixed(1)
              item.value = `${value}%`
            }
          })
          origins.map((origin) => {
            if (item.key === origin) {
              item.value = details.data[origin]
            }
          })
          return item
        })
      }
      return this.items
    },
  },
  created() {
    this.fetchingDetail()
  },
  methods: {
    ...measureDetailsMethods,
    handleDelete() {
      const { id } = this.$route.params
      this.deleteMeasureById({ id })
      this.$router.push('/panel/measure-list')
    },
    fetchingDetail() {
      const { id } = this.$route.params
      this.getDetailsById({ id })
    },
  },
}
</script>

<template>
  <div>
    <BaseAddNewCard type="delete" @submit="handleDelete">
      <template v-slot:header>
        <h5 class="card-title">{{ title }}</h5>
      </template>
      <template v-slot>
        <CRow
          v-for="item in itemsComputed"
          :key="item.key"
          class="under-line d-flex align-items-center custom-width"
        >
          <CCol sm="3">
            <p>{{ item.label }}</p>
          </CCol>
          <CCol sm="9" class="feeline-color-content">
            <span>{{ $options.COMMENT_LEVEL[item.subValue] }}</span>
            <BaseInput
              v-if="item.as === 'plaintext'"
              :type="item.type"
              :value="item.value"
              plaintext
            />
          </CCol>
        </CRow>
      </template>
      <template v-slot:action>
        <div class="custom-width">
          <CButton color="primary" type="submit">
            {{ buttonTitle }}
          </CButton>
        </div>
      </template>
    </BaseAddNewCard>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .feeline-color-content {
  color: $gray-900;
}
.under-line {
  padding-top: 10px;
  border-top: 1px solid #c8ced3;

  &:first-child {
    padding-top: 0;
    border-top: 0;
  }
}
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}

@media screen and (min-width: 1224px) {
  .custom-width {
    width: 50%;
  }
}
@media screen and (max-width: 1223px) {
  .custom-width {
    width: 100%;
  }
}
</style>
